import { render, staticRenderFns } from "./AdminManageCertifications.vue?vue&type=template&id=6fcc7775"
import script from "./AdminManageCertifications.vue?vue&type=script&lang=js"
export * from "./AdminManageCertifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports